// extracted by mini-css-extract-plugin
export default {"floating-button-v2":"floating-button_floating-button-v2__sTuP3","floating-button":"floating-button_floating-button__Vqp1J"};